import { useActor } from '@ui-common/hooks/useActor'
import { useSelector } from '@xstate/react'
import { useCallback, useMemo } from 'react'

import {
  ENSURE_BFF_AVAILABILITY,
  ERROR,
  GET_AND_STORE_INPUT_PARAMS,
  GET_CONFIG,
  initializeStepMachine,
} from './initializeStepMachine'
import { InitializeStepProps } from './types'

interface InitializeStepState {
  isLoading: boolean
  hasError: boolean
  exit: () => void
}

export const useInitializeStepState = (props: InitializeStepProps): InitializeStepState => {
  const actor = useActor(initializeStepMachine, { input: props })
  const state = useSelector(actor, (snapshot) => snapshot.value)

  const loadingStates = [GET_AND_STORE_INPUT_PARAMS, GET_CONFIG, ENSURE_BFF_AVAILABILITY]
  const isLoading = loadingStates.includes(state)
  const hasError = state === ERROR

  const exit = useCallback(() => actor.send({ type: 'EXIT' }), [actor])

  return useMemo(() => ({ isLoading, hasError, exit }), [isLoading, hasError, exit])
}
